module.exports = __webpack_public_path__ + "static/carrera-ab426a8da369c99339582e62b217414b.png";